module.exports = __webpack_public_path__ + "static/media/logo.edae04c3.png";